<header class="titlebar">
  <h3>{{ "Template.SettingsComponent.subHeader_settings" | translate }}</h3>
</header>

<div class="row">
  <section class="col-sm-12 col-md-5">
    <h5>{{ "Template.SettingsComponent.subHeader_myData" | translate }}:</h5>

    @if (currentUser && currentUser.externalAuthId) {
      <div class="mt-2">
        <label>{{ "Template.SettingsComponent.label_name" | translate }}</label>
        <div class="row">
          <div class="col-6">
            <input type="text" class="form-control form-control-plaintext" [value]="currentUser.firstname" [readonly]="true" />
          </div>
          <div class="col-6">
            <input type="text" class="form-control form-control-plaintext" [value]="currentUser.lastname" [readonly]="true" />
          </div>
        </div>
        <button type="submit" class="btn btn-outline-secondary d-block w-100" (click)="openEditSsoName()" [disabled]="ssoProfileEditLoading">
          @if (ssoProfileEditLoading) {
            <fa-icon icon="spinner" animation="spin"></fa-icon>
          }
          {{ "Template.SettingsComponent.btn_editSsoProfile" | translate }}
          <fa-icon icon="chevron-right"></fa-icon>
        </button>
      </div>
    }

    @if (currentUser && currentUser.externalAuthId) {
      <div class="mt-4">
        <label for="email">{{ "Template.SettingsComponent.label_emailAdress" | translate }}</label>
        <input id="email" type="text" class="form-control form-control-plaintext" [value]="currentUser.email" [readonly]="true" />
        <button type="submit" class="btn btn-outline-secondary d-block w-100" (click)="openEditSsoEmail()" [disabled]="ssoProfileEditLoading">
          @if (ssoEmailChangeLoading) {
            <fa-icon icon="spinner" animation="spin"></fa-icon>
          }
          {{ "Template.SettingsComponent.btn_editSsoEmail" | translate }}
          <fa-icon icon="chevron-right"></fa-icon>
        </button>
      </div>
    }

    @if (currentUser && !currentUser.externalAuthId) {
      <app-legacy-profile [currentUser]="currentUser"> </app-legacy-profile>
    }
  </section>

  <section class="col-sm-12 col-md-5 offset-1">
    @if (environment.sso.enabled) {
      <div>
        <div class="row">
          <div class="col">
            <h5>EK Single Sign On</h5>
          </div>
          <div class="col-2">
            <img src="assets/images/sso/sso-badge-sm.png" alt="SSO Logo" class="img-fluid" />
          </div>
        </div>
        @if (!currentUser?.externalAuthId) {
          <div class="mt-2">
            @if (loadingSso) {
              <fa-icon icon="spinner" size="2x" class="px-3 mt-2" animation="spin"></fa-icon>
            }
            @if (!loadingSso && !ssoUserExists) {
              <div>
                <p class="mb-2">
                  {{ "Template.SsoSettingsComponent.text_registerAccount" | translate }}
                </p>
                <button type="button" class="btn btn-secondary d-block w-100 mb-3" (click)="redirectToRegister()" [disabled]="registeringSso">
                  <fa-icon icon="user-plus" class="me-2"></fa-icon>
                  {{ "Template.SsoSignupFormComponent.btn_signupSso" | translate }}
                  @if (registeringSso) {
                    <fa-icon icon="spinner" animation="spin" class="ms-2"></fa-icon>
                  }
                </button>
              </div>
            }
            @if (!loadingSso && ssoUserExists) {
              <div>
                <p class="mb-2">
                  {{ "Template.SsoSettingsComponent.text_linkAccount" | translate }}
                </p>
                <button type="button" type="button" class="btn btn-secondary d-block w-100" (click)="redirectToSignInAndLink()" [disabled]="linkingSso">
                  <fa-icon icon="link" class="me-2"></fa-icon>
                  {{ "Template.SsoSettingsComponent.btn_linkAccount" | translate }}
                  @if (linkingSso) {
                    <fa-icon icon="spinner" animation="spin" class="ms-2"></fa-icon>
                  }
                </button>
              </div>
            }
          </div>
        }
        @if (currentUser?.externalAuthId) {
          <div class="mt-2">
            <button type="submit" class="btn btn-outline-danger d-block w-100" (click)="openResetSsoPassword()" [disabled]="ssoPasswordLoading">
              @if (ssoPasswordLoading) {
                <fa-icon icon="spinner" animation="spin"></fa-icon>
              }
              {{ "Template.SettingsComponent.btn_resetSsoPassword" | translate }}
              <fa-icon icon="chevron-right"></fa-icon>
            </button>
          </div>
        }
        @if (!loadingSso) {
          <div class="border rounded-3 px-2 py-2 mt-3">
            <div class="row">
              <div class="col-auto pe-0 pt-1">
                <fa-icon icon="info-circle" class="text-primary" size="lg"></fa-icon>
              </div>
              <div class="col">
                <small class="d-block text-muted">
                  {{ "Template.SsoSettingsComponent.text_explanation" | translate }}
                </small>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <div [class]="{ 'mt-3': environment.sso.enabled }">
      @if (environment.sso.enabled) {
        <hr />
      }
      @if (currentUser) {
        <div class="form-group">
          <label>{{ "Template.SettingsComponent.text_language" | translate }}</label>
          <select class="form-select" [(ngModel)]="selectedLanguage" (change)="onLangChange(selectedLanguage)">
            <option class="dropdown-item" value="de">Deutsch</option>
            <option class="dropdown-item" value="en">English</option>
          </select>
        </div>
      }
    </div>

    @if (currentUser?.roles?.includes('ROLE_ADMIN')) {
      <div class="mt-3">
        <hr />
        <button class="btn d-block w-100 btn-secondary" (click)="openAdminModal(adminModal)">
          {{ "Template.SettingsComponent.btn_addAdmin" | translate }}
        </button>
      </div>
    }
  </section>
</div>

<ng-template #adminModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ "Template.SettingsComponent.subHeader_createAdmin" | translate }}</h4>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <app-create-user-form [userProps]="userProps" (exitFormEvent)="exitUserForm($event)"></app-create-user-form>
    </div>
  </div>
</ng-template>
